// Check environment to get API Gateway base URL
const env = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'testing';
const ENVIRONMENT = env === 'testing' || env === 'development' ? '-own' : env === 'staging' ? '-test' : '';

export const GAConfig = env === 'development' || env === 'testing' ? 'G-RR3YSTHBJ5' : 'G-ED7ZZD8YCX';
const API_URL = `https://bc-api${ENVIRONMENT}.dinclin.com`;
// const API_URL_LOCAL= 'http://localhost:64102';

console.log({
  API_URL,
  ENVIRONMENT,
  env,
  REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  NODE_ENV: process.env.NODE_ENV,
})

const FILL_PDF = process.env.FILL_PDF || '/pdf/fill';

const REQUEST_DATA = process.env.REACT_APP_REQUEST_DATA || '/operations/getbyhash';

const VERIFY_SECURITY = process.env.REACT_APP_VERIFY_SECURITY || '/operations/operationVerify';

const NOTIFICATE_CONTRACT = process.env.NOTIFICATE_CONTRACT || '/operations/notificate';

const UPDATE_OPERATION = process.env.UPDATE_OPERATION || '/operations';


export const operationDataEndpoint = (hash) => `${API_URL}${REQUEST_DATA}/${hash}`;

export const verifySecurityEndpoint = (hash) => `${API_URL}${VERIFY_SECURITY}/${hash}`;

export const generatePdfEndpoint = () => `${API_URL}${FILL_PDF}`;

export const signContractEndpoint = (id) => `${API_URL}/operations/${id}/sign`;

export const updateDataEndpoint = (id) => `${API_URL}${UPDATE_OPERATION}/${id}`;

export const notificateOperationsEndpoint = () => `${API_URL}${NOTIFICATE_CONTRACT}`;
